// TODO: torn, can either bake this here; or have to create a whole new button type
// Only ways that you can pass in a custom React component for render :l
import {
  // ExpandableToolbarButton,
  // ListMenu,
  WindowLevelMenuItem,
} from '@ohif/ui';
import { defaults } from '@ohif/core';

const { windowLevelPresets } = defaults;
/**
 *
 * @param {*} type - 'tool' | 'action' | 'toggle'
 * @param {*} id
 * @param {*} icon
 * @param {*} label
 */
function _createButton(type, id, icon, label, commands, tooltip, uiType) {
  return {
    id,
    icon,
    label,
    type,
    commands,
    tooltip,
    uiType,
  };
}

const _createActionButton = _createButton.bind(null, 'action');
const _createToggleButton = _createButton.bind(null, 'toggle');
const _createToolButton = _createButton.bind(null, 'tool');

/**
 *
 * @param {*} preset - preset number (from above import)
 * @param {*} title
 * @param {*} subtitle
 */
function _createWwwcPreset(preset, title, subtitle) {
  return {
    id: preset.toString(),
    title,
    subtitle,
    type: 'action',
    commands: [
      {
        commandName: 'setWindowLevel',
        commandOptions: {
          ...windowLevelPresets[preset],
        },
        context: 'CORNERSTONE',
      },
    ],
  };
}

const toolGroupIds = ['default', 'mpr', 'SRToolGroup'];

/**
 * Creates an array of 'setToolActive' commands for the given toolName - one for
 * each toolGroupId specified in toolGroupIds.
 * @param {string} toolName
 * @returns {Array} an array of 'setToolActive' commands
 */
function _createSetToolActiveCommands(toolName) {
  const temp = toolGroupIds.map(toolGroupId => ({
    commandName: 'setToolActive',
    commandOptions: {
      toolGroupId,
      toolName,
    },
    context: 'CORNERSTONE',
  }));
  return temp;
}

const toolbarButtons = [
  // Measurement
  {
    id: 'MeasurementTools',
    type: 'ohif.splitButton',
    props: {
      groupId: 'MeasurementTools',
      isRadio: true, // ?
      // Switch?
      primary: _createToolButton(
        'Length',
        'tool-length',
        'Length',
        [
          {
            commandName: 'setToolActive',
            commandOptions: {
              toolName: 'Length',
            },
            context: 'CORNERSTONE',
          },
          {
            commandName: 'setToolActive',
            commandOptions: {
              toolName: 'SRLength',
              toolGroupId: 'SRToolGroup',
            },
            // we can use the setToolActive command for this from Cornerstone commandsModule
            context: 'CORNERSTONE',
          },
        ],
        'Length'
      ),
      secondary: {
        icon: 'chevron-down',
        label: '',
        isActive: true,
        tooltip: 'Mais Ferramentas de Medição',
      },
      items: [
        _createToolButton(
          'Length',
          'tool-length',
          'Length',
          [
            {
              commandName: 'setToolActive',
              commandOptions: {
                toolName: 'Length',
              },
              context: 'CORNERSTONE',
            },
            {
              commandName: 'setToolActive',
              commandOptions: {
                toolName: 'SRLength',
                toolGroupId: 'SRToolGroup',
              },
              // we can use the setToolActive command for this from Cornerstone commandsModule
              context: 'CORNERSTONE',
            },
          ],
          'Length Tool'
        ),

        _createToolButton(
          'ReferenceLines',
          'tool-referenceLines', // change this with the new icon
          'Linhas de Referência',
          [
            {
              commandName: 'toggleReferenceLines',
              commandOptions: {},
              context: 'CORNERSTONE',
            },
          ]
        ),

        _createToolButton(
          'Bidirecional',
          'tool-bidirectional',
          'Bidirecional',
          [
            {
              commandName: 'setToolActive',
              commandOptions: {
                toolName: 'Bidirecional',
              },
              context: 'CORNERSTONE',
            },
            {
              commandName: 'setToolActive',
              commandOptions: {
                toolName: 'SRBidirectional',
                toolGroupId: 'SRToolGroup',
              },
              context: 'CORNERSTONE',
            },
          ],
          'Bidirecional Tool'
        ),
        _createToolButton(
          'ArrowAnnotate',
          'tool-annotate',
          'Anotação',
          [
            {
              commandName: 'setToolActive',
              commandOptions: {
                toolName: 'ArrowAnnotate',
              },
              context: 'CORNERSTONE',
            },
            {
              commandName: 'setToolActive',
              commandOptions: {
                toolName: 'SRArrowAnnotate',
                toolGroupId: 'SRToolGroup',
              },
              context: 'CORNERSTONE',
            },
          ],
          'Arrow Annotate'
        ),
        _createToolButton(
          'EllipticalROI',
          'tool-elipse',
          'Ellipse',
          [
            {
              commandName: 'setToolActive',
              commandOptions: {
                toolName: 'EllipticalROI',
              },
              context: 'CORNERSTONE',
            },
            {
              commandName: 'setToolActive',
              commandOptions: {
                toolName: 'SREllipticalROI',
                toolGroupId: 'SRToolGroup',
              },
              context: 'CORNERSTONE',
            },
          ],
          'Ellipse Tool'
        ),
      ],
    },
  },

  // Next..
  {
    id: 'Prev',
    type: 'ohif.radioGroup',
    props: {
      type: 'tool',
      icon: 'arrow-up-menu',
      label: 'Série Anterior',
      commands: [
        {
          commandName: 'thumbnailHandler',
          commandOptions: {
            toolName: 'Prev',
            index: -1
          },
          context: 'DEFAULT',
        },
      ],
    },
  },

  {
    id: 'Next',
    type: 'ohif.radioGroup',
    props: {
      type: 'tool',
      icon: 'arrow-down-menu',
      label: 'Próxima Série',
      commands: [
        {
          commandName: 'thumbnailHandler',
          commandOptions: {
            toolName: 'Next',
            index: 1
          },
          context: 'DEFAULT',
        },
      ],
    },
  },

  // Zoom..
  {
    id: 'Zoom',
    type: 'ohif.radioGroup',
    props: {
      type: 'tool',
      icon: 'tool-zoom',
      label: 'Zoom',
      commands: _createSetToolActiveCommands('Zoom'),
    },
  },

  // Angle
  {
    id: 'Angle',
    type: 'ohif.radioGroup',
    props: {
      type: 'tool',
      icon: 'tool-angle',
      label: 'Angle',
      commands: [
        {
          commandName: 'setToolActive',
          commandOptions: {
            toolName: 'Angle',
          },
          context: 'CORNERSTONE',
        },
      ],
    },
  },

  //StackScroll
  {
    id: 'StackScroll',
    type: 'ohif.radioGroup',
    props: {
      type: 'tool',
      icon: 'tool-stack-scroll',
      label: 'Navegar',
      commands: [
        {
          commandName: 'setToolActive',
          commandOptions: {
            toolName: 'StackScroll',
          },
          context: 'CORNERSTONE',
        },
      ],
    },
  },

  //StackImageSync
  {
    id: 'StackImageSync',
    type: 'ohif.radioGroup',
    props: {
      type: 'tool',
      icon: 'link',
      label: 'Sincronizar',
      commands: [
        {
          commandName: 'toggleStackImageSync',
          commandOptions: {
            toolName: 'toggleStackImageSync',
            toggledState: true
          },
          context: 'CORNERSTONE',
        },
      ],
    },
  },

  //ArrowAnnotate
  {
    id: 'ArrowAnnotate',
    type: 'ohif.radioGroup',
    props: {
      type: 'tool',
      icon: 'tool-annotate',
      label: 'Anotar',
      commands: [
        {
          commandName: 'setToolActive',
          commandOptions: {
            toolName: 'ArrowAnnotate',
          },
          context: 'CORNERSTONE',
        },
      ],
    },
  },

  //Reset
  {
    id: 'Reset',
    type: 'ohif.radioGroup',
    props: {
      type: 'tool',
      icon: 'tool-reset',
      label: 'Restaurar',
      commands: [
        {
          commandName: 'resetViewport',
          commandOptions: {
            toolName: 'Reset',
          },
          context: 'CORNERSTONE',
        },
      ],
    },
  },

  //Cine
  {
    id: 'Cine',
    type: 'ohif.radioGroup',
    props: {
      type: 'tool',
      icon: 'tool-cine',
      label: 'Cine',
      commands: [
        {
          commandName: 'toggleCine',
          commandOptions: {
            toolName: 'Reset',
          },
          context: 'CORNERSTONE',
        },
      ],
    },
  },

  // Window Level + Presets...
  {
    id: 'WindowLevel',
    type: 'ohif.splitButton',
    props: {
      groupId: 'WindowLevel',
      primary: _createToolButton(
        'WindowLevel',
        'tool-window-level',
        'Window Level',
        [
          {
            commandName: 'setToolActive',
            commandOptions: {
              toolName: 'WindowLevel',
            },
            context: 'CORNERSTONE',
          },
        ],
        'Window Level'
      ),
      secondary: {
        icon: 'chevron-down',
        label: 'W/L Manual',
        isActive: true,
        tooltip: 'W/L Presets',
      },
      isAction: true, // ?
      renderer: WindowLevelMenuItem,
      items: [
        _createWwwcPreset(1, 'Soft tissue', '400 / 40'),
        _createWwwcPreset(2, 'Lung', '1500 / -600'),
        _createWwwcPreset(3, 'Liver', '150 / 90'),
        _createWwwcPreset(4, 'Bone', '2500 / 480'),
        _createWwwcPreset(5, 'Brain', '80 / 40'),
      ],
    },
  },
  // Arrastar...
  {
    id: 'Arrastar',
    type: 'ohif.radioGroup',
    props: {
      type: 'tool',
      icon: 'tool-move',
      label: 'Arrastar',
      commands: _createSetToolActiveCommands('Arrastar'),
    },
  },
  {
    id: 'Capture',
    type: 'ohif.action',
    props: {
      icon: 'tool-capture',
      label: 'Capture',
      type: 'action',
      commands: [
        {
          commandName: 'showDownloadViewportModal',
          commandOptions: {},
          context: 'CORNERSTONE',
        },
      ],
    },
  },
  {
    id: 'Layout',
    type: 'ohif.layoutSelector',
    props: {
      rows: 3,
      columns: 3,
    },
  },
  {
    id: 'MPR',
    type: 'ohif.action',
    props: {
      type: 'toggle',
      icon: 'icon-mpr',
      label: 'MPR',
      commands: [
        {
          commandName: 'toggleHangingProtocol',
          commandOptions: {
            protocolId: 'mpr',
          },
          context: 'DEFAULT',
        },
      ],
    },
  },
  {
    id: 'Localizador',
    type: 'ohif.radioGroup',
    props: {
      type: 'tool',
      icon: 'tool-crosshair',
      label: 'Localizador',
      commands: [
        {
          commandName: 'setToolActive',
          commandOptions: {
            toolName: 'Localizador',
            toolGroupId: 'mpr',
          },
          context: 'CORNERSTONE',
        },
      ],
    },
  },
  // More...
  {
    id: 'MoreTools',
    type: 'ohif.splitButton',
    props: {
      isRadio: true, // ?
      groupId: 'MoreTools',
      primary: _createActionButton(
        'Reset',
        'tool-rotate-right',
        'Virar à Direita',
        [
          {
            commandName: 'resetViewport',
            commandOptions: {},
            context: 'CORNERSTONE',
          },
        ],
        'Reset'
      ),
      secondary: {
        icon: 'chevron-down',
        label: '',
        isActive: true,
        tooltip: 'Mais',
      },
      items: [
        _createActionButton(
          'Reset',
          'tool-reset',
          'Reset View',
          [
            {
              commandName: 'resetViewport',
              commandOptions: {},
              context: 'CORNERSTONE',
            },
          ],
          'Restaurar'
        ),
        _createActionButton(
          'rotate-right',
          'tool-rotate-right',
          'Rotate Right',
          [
            {
              commandName: 'rotateViewportCW',
              commandOptions: {},
              context: 'CORNERSTONE',
            },
          ],
          'Virar +90'
        ),
        _createActionButton(
          'flip-horizontal',
          'tool-flip-horizontal',
          'Flip Horizontally',
          [
            {
              commandName: 'flipViewportHorizontal',
              commandOptions: {},
              context: 'CORNERSTONE',
            },
          ],
          'Inverter Horizontal'
        ),
        _createToggleButton(
          'ReferenceLines',
          'tool-referenceLines', // change this with the new icon
          'Reference Lines',
          [
            {
              commandName: 'toggleReferenceLines',
              commandOptions: {},
              context: 'CORNERSTONE',
            },
          ]
        ),
        _createActionButton(
          'invert',
          'tool-invert',
          'Invert',
          [
            {
              commandName: 'invertViewport',
              commandOptions: {},
              context: 'CORNERSTONE',
            },
          ],
          'Invert Colors'
        ),
        _createToolButton(
          'Probe',
          'tool-probe',
          'Probe',
          [
            {
              commandName: 'setToolActive',
              commandOptions: {
                toolName: 'DragProbe',
              },
              context: 'CORNERSTONE',
            },
          ],
          'Probe'
        ),

        // Next two tools can be added once icons are added
        // _createToolButton(
        //   'Cobb Angle',
        //   'tool-cobb-angle',
        //   'Cobb Angle',
        //   [
        //     {
        //       commandName: 'setToolActive',
        //       commandOptions: {
        //         toolName: 'CobbAngle',
        //       },
        //       context: 'CORNERSTONE',
        //     },
        //   ],
        //   'Cobb Angle'
        // ),
        // _createToolButton(
        //   'Planar Freehand ROI',
        //   'tool-freehand',
        //   'PlanarFreehandROI',
        //   [
        //     {
        //       commandName: 'setToolActive',
        //       commandOptions: {
        //         toolName: 'PlanarFreehandROI',
        //       },
        //       context: 'CORNERSTONE',
        //     },
        //   ],
        //   'Planar Freehand ROI'
        // ),
        _createToolButton(
          'Magnify',
          'tool-magnify',
          'Magnify',
          [
            {
              commandName: 'setToolActive',
              commandOptions: {
                toolName: 'Magnify',
              },
              context: 'CORNERSTONE',
            },
          ],
          'Magnify'
        ),
        _createToolButton(
          'Rectangle',
          'tool-rectangle',
          'Rectangle',
          [
            {
              commandName: 'setToolActive',
              commandOptions: {
                toolName: 'RectangleROI',
              },
              context: 'CORNERSTONE',
            },
          ],
          'Rectangle'
        ),
        _createToolButton(
          'CalibrationLine',
          'tool-calibration',
          'Calibração',
          [
            {
              commandName: 'setToolActive',
              commandOptions: {
                toolName: 'CalibrationLine',
              },
              context: 'CORNERSTONE',
            },
          ],
          'Calibration Line'
        ),
        _createActionButton(
          'TagBrowser',
          'list-bullets',
          'Dicom Tag Browser',
          [
            {
              commandName: 'openDICOMTagViewer',
              commandOptions: {},
              context: 'DEFAULT',
            },
          ],
          'Dicom Tag Browser'
        ),
        _createActionButton(
          'ImagemSecundaria',
          'copy-image',
          'Imagem Secundária',
          [
            {
              commandName: 'gerarImagemSecundaria',
              commandOptions: {},
              context: 'DEFAULT',
            },
          ],
          'Imagem Secundária'
        ),

        /*/
        _createActionButton(
        'Segmentação',
        'tool-zoom',
        'Segmentação',
        [
        {
        commandName: 'addSegmentation',
        commandOptions: {},
        context: 'DEFAULT',
        },
        ],
        'Segmentação'
        ),
        
        // Segmentação
        {
        id: 'Segmentação',
        type: 'ohif.radioGroup',
        props: {
        type: 'tool',
        icon: 'tool-zoom',
        label: 'Segmentação',
        commands: [
        {
        commandName: 'addSegmentation',
        commandOptions: {
        toolName: 'Segmentação',
        },
        context: 'CORNERSTONE',
        },
        ],
        },
        },
        /*/

        _createActionButton(
          'AslViewer',
          'eye-visible',
          'Asl Viewer',
          [
            {
              commandName: 'abrirAslViewer',
              commandOptions: {
                toolName: 'AslViewer'
              },
              context: 'DEFAULT',
            },
          ],
          'Asl Viewer'
        ),

        _createActionButton(
          'Download',
          'arrow-down',
          'Baixar',
          [
            {
              commandName: 'downloadDicomImagesZip',
              commandOptions: {
                toolName: 'Download'
              },
              context: 'DEFAULT',
            },
          ],
          'Baixar'
        ),
      ],
    },
  },

  //AslViewer
  {
    id: 'AslViewer',
    type: 'ohif.radioGroup',
    props: {
      id: 'AslViewer',
      type: 'tool',
      icon: 'eye-visible',
      label: 'Asl Viewer',
      commands: [
        {
          commandName: 'abrirAslViewer',
          commandOptions: {
            toolName: 'AslViewer'
          },
          context: 'DEFAULT',
        },
      ],
    },
  },

  //Download
  {
    id: 'Download',
    type: 'ohif.radioGroup',
    props: {
      type: 'tool',
      icon: 'arrow-down',
      label: 'Download',
      commands: [
        {
          commandName: 'downloadDicomImagesZip',
          commandOptions: {
            toolName: 'Download',
          },
          context: 'DEFAULT',
        },
      ],
    },
  },

  //ImageOverlay
  {
    id: 'ImageOverlay',
    type: 'ohif.radioGroup',
    props: {
      id: 'ImageOverlay',
      type: 'tool',
      icon: 'tab-patient-info',
      label: 'Habilitar/Desabilitar Overlay',
      commands: [
        {
          commandName: 'toggleOverlays',
          commandOptions: {
            toolName: 'toggleOverlays',
          },
          context: 'DEFAULT',
        },
      ],
    },
  },

  {
    id: 'ImageOverlayViewer',
    type: 'ohif.radioGroup',
    props: {
      id: 'ImageOverlayViewer',
      type: 'tool',
      icon: 'tool-imageoverlay',
      label: 'Habilitar/Desabilitar Anotações',
      commands: [
        {
          commandName: 'toggleImageOverlay',
          commandOptions: {
            toolName: 'toggleImageOverlay',
          },
          context: 'DEFAULT',
        },
      ],
    },
  },

];

export default toolbarButtons;
